import { isNil } from 'lodash';
import { isInputComponent, isRelatedCardLookupComponent } from '@shared/scenes/workflows/utils';
import { API } from '@shared/types/api';
import { STATIC_COMPONENT_IDS } from './staticComponentIds';
import type { Entity } from './types';

export function toCreateWorkflowEntity(
  entity: Entity,
  workflowTemplate?: API.WorkflowTemplateFragment,
): API.CreateWorkflowEntity {
  const { allFields, workflowTemplateId } = entity;

  const fields: { [componentId: string]: any } = {};
  allFields.forEach((value, key) => {
    if (!isNil(workflowTemplate) && isCreateableField(key, workflowTemplate)) {
      fields[key] = value?.toFieldJson() ?? undefined;
    }
  });

  return {
    fields,
    workflowTemplateId,
  };
}

export function isCreateableField(
  fieldKey: string,
  workflowTemplate?: API.WorkflowTemplateFragment,
): boolean {
  const component = workflowTemplate?.components?.find(c => c.id === fieldKey);
  return (
    !isNil(component) &&
    isInputComponent(component) &&
    !isRelatedCardLookupComponent(component) &&
    component.isServerManaged !== true
  );
}

export function isDeletedEntity(entity?: API.WorkflowEntity): boolean {
  const deletedAt = entity?.fields?.[STATIC_COMPONENT_IDS.DELETED_AT];
  return !isNil(entity) && !isNil(deletedAt);
}
